import structures from '@/structures';

const StructCaller = {
  /**
   * @function getStructData Returns data of struct based on passed key, and value.
   *
   * @param {String} structName  name of structure we wont to call
   * @param {String} key nam of key in this struct we wanna search by
   * @param {*} value value of key we wanna search
   *
   *
   * @returns {Object} returns structure object, or empty object if not finded;
   */
  getStructData(structName, key, value) {
    let neededStruct = {};
    if (structName in structures) {
      neededStruct = structures[structName].find(s => {
        return s[key] === value;
      });

      if (!neededStruct) {
        neededStruct = structures['DEFAULT_ERROR'];
      }

      return neededStruct || false;
    } else {
      console.error(`Got no structure with name ${structName}`);
    }
  },
};

export default StructCaller;
